import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const START_SECONDS = 17 * 60 + 34;
type CountdownProps = {
  dark?: boolean;
};
export function Countdown({
  dark = false
}: CountdownProps) {
  const [seconds, setSeconds] = useState(START_SECONDS);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setSeconds(s => s <= 1 ? START_SECONDS : s - 1);
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const hh = '00';
  const mm = String(Math.floor(seconds / 60)).padStart(2, '0');
  const ss = String(seconds % 60).padStart(2, '0');
  const blocks = [{
    value: hh,
    label: 'Hours'
  }, {
    value: mm,
    label: 'Minutes'
  }, {
    value: ss,
    label: 'Seconds'
  }];
  return <div className="mt-6 flex flex-col items-center" role="timer" aria-live="off" data-id="element-127" data-mp="3731fucp2hq6k">
      <p className={`flex items-center gap-2 text-sm font-bold uppercase tracking-wider ${dark ? 'text-gold-light' : 'text-gold-dark'}`} data-id="element-128" data-mp="10cv1q7euidg5">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-129" data-mp="y16m3ddt2bsa" />
        Special offer ends in:
      </p>
      <div className="mt-3 flex items-start gap-2 sm:gap-3" data-id="element-130" data-mp="t23djiym9nfk">
        {blocks.map((b, i) => <React.Fragment key={b.label} data-id="element-131" data-mp="17qzwib27okuy" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-132" data-mp="17pya5afqwbxx">
              <span className="flex h-16 w-16 sm:h-20 sm:w-20 items-center justify-center rounded-xl bg-ink font-serif text-3xl sm:text-4xl font-black tabular-nums text-gold-light ring-1 ring-gold/40" data-id="element-133" data-mp="12rwpwm6l26kv">
                {b.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${dark ? 'text-white/60' : 'text-ink/50'}`} data-id="element-134" data-mp="a4j0d957sdas">
                {b.label}
              </span>
            </div>
            {i < blocks.length - 1 && <span className={`pt-4 sm:pt-6 font-serif text-2xl font-black ${dark ? 'text-gold-light' : 'text-gold-dark'}`} data-id="element-135" data-mp="k3rq1pt1r5rc">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}